import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { SIDEBAR_TAB_KEYS } from '@/helper/const';
import { UICard, UIContentWrap, UITextSmMedium } from '@gohighlevel/ghl-ui';
import ChatWidgetPreview from './ChatWidgetPreview.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BuilderPreview',
    props: {
        activeTab: {
            type: String,
            default: '',
        },
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIContentWrap), { class: "chat-widget-builder-preview bg-gray-50" }, {
                default: _withCtx(() => [
                    _createVNode(_unref(UITextSmMedium), { class: "pb-2" }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('builder.chatWidgetPreview')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(_unref(UICard), { class: "relative chat-widget-builder-preview-card" }, {
                        default: _withCtx(() => [
                            (props.activeTab === _unref(SIDEBAR_TAB_KEYS).WIDGET)
                                ? (_openBlock(), _createBlock(ChatWidgetPreview, {
                                    key: 0,
                                    "tab-type": _unref(SIDEBAR_TAB_KEYS).WIDGET
                                }, null, 8 /* PROPS */, ["tab-type"]))
                                : _createCommentVNode("v-if", true),
                            (props.activeTab === _unref(SIDEBAR_TAB_KEYS).CHAT_WINDOW)
                                ? (_openBlock(), _createBlock(ChatWidgetPreview, {
                                    key: 1,
                                    "tab-type": _unref(SIDEBAR_TAB_KEYS).CHAT_WINDOW
                                }, null, 8 /* PROPS */, ["tab-type"]))
                                : _createCommentVNode("v-if", true),
                            (props.activeTab === _unref(SIDEBAR_TAB_KEYS).MESSAGING)
                                ? (_openBlock(), _createBlock(ChatWidgetPreview, {
                                    key: 2,
                                    "tab-type": _unref(SIDEBAR_TAB_KEYS).MESSAGING
                                }, null, 8 /* PROPS */, ["tab-type"]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
